<template>
  <router-view />
</template>

<script>

export default {
  name: 'VatWrapper'
}
</script>
